import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _invoke from "lodash/invoke";
import { checkboxBehavior } from '@stardust-ui/accessibility';
import * as customPropTypes from '@stardust-ui/react-proptypes';
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { applyAccessibilityKeyHandlers, AutoControlledComponent, createShorthandFactory, commonPropTypes } from '../../lib';
import { withSafeTypeForAs } from '../../types';
import Icon from '../Icon/Icon';
import Text from '../Text/Text';

var Checkbox =
/*#__PURE__*/
function (_AutoControlledCompon) {
  _inherits(Checkbox, _AutoControlledCompon);

  function Checkbox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Checkbox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "actionHandlers", {
      performClick: function performClick(e)
      /* TODO: use React.KeyboardEvent */
      {
        e.preventDefault();

        _this.handleClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e) {
      // Checkbox component doesn't present any `input` component in markup, however all of our
      // components should handle events transparently.
      var disabled = _this.props.disabled;
      var checked = !_this.state.checked;

      if (!disabled) {
        _this.setState({
          checked: checked
        });

        _invoke(_this.props, 'onChange', e, Object.assign({}, _this.props, {
          checked: checked
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var disabled = _this.props.disabled;
      var checked = !_this.state.checked;

      if (!disabled) {
        _this.setState({
          checked: checked
        });

        _invoke(_this.props, 'onClick', e, Object.assign({}, _this.props, {
          checked: checked
        }));

        _invoke(_this.props, 'onChange', e, Object.assign({}, _this.props, {
          checked: checked
        }));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e) {
      _invoke(_this.props, 'onFocus', e, _this.props);
    });

    return _this;
  }

  _createClass(Checkbox, [{
    key: "getInitialAutoControlledState",
    value: function getInitialAutoControlledState() {
      return {
        checked: false
      };
    }
  }, {
    key: "renderComponent",
    value: function renderComponent(_ref) {
      var _this2 = this;

      var ElementType = _ref.ElementType,
          classes = _ref.classes,
          unhandledProps = _ref.unhandledProps,
          styles = _ref.styles,
          accessibility = _ref.accessibility;
      var _this$props = this.props,
          label = _this$props.label,
          labelPosition = _this$props.labelPosition,
          icon = _this$props.icon,
          toggle = _this$props.toggle;
      var labelElement = Text.create(label, {
        defaultProps: function defaultProps() {
          return {
            styles: styles.label,
            className: Checkbox.slotClassNames.label
          };
        }
      });
      return React.createElement(ElementType, _extends({
        className: classes.root,
        onClick: this.handleClick,
        onChange: this.handleChange,
        onFocus: this.handleFocus
      }, accessibility.attributes.root, unhandledProps, applyAccessibilityKeyHandlers(accessibility.keyHandlers.root, unhandledProps)), labelPosition === 'start' && labelElement, Icon.create(icon, {
        defaultProps: function defaultProps() {
          return {
            outline: toggle && !_this2.state.checked,
            size: toggle ? 'medium' : 'smaller',
            className: Checkbox.slotClassNames.indicator,
            name: toggle ? 'stardust-circle' : 'stardust-checkmark',
            styles: toggle ? styles.toggle : styles.checkbox
          };
        }
      }), labelPosition === 'end' && labelElement);
    }
  }]);

  return Checkbox;
}(AutoControlledComponent);

_defineProperty(Checkbox, "slotClassNames", void 0);

_defineProperty(Checkbox, "create", void 0);

_defineProperty(Checkbox, "displayName", 'Checkbox');

_defineProperty(Checkbox, "className", 'ui-checkbox');

_defineProperty(Checkbox, "propTypes", Object.assign({}, commonPropTypes.createCommon({
  content: false
}), {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: customPropTypes.itemShorthandWithoutJSX,
  label: customPropTypes.itemShorthand,
  labelPosition: PropTypes.oneOf(['start', 'end']),
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  toggle: PropTypes.bool
}));

_defineProperty(Checkbox, "defaultProps", {
  accessibility: checkboxBehavior,
  icon: {},
  labelPosition: 'end'
});

_defineProperty(Checkbox, "autoControlledProps", ['checked']);

Checkbox.slotClassNames = {
  label: "".concat(Checkbox.className, "__label"),
  indicator: "".concat(Checkbox.className, "__indicator")
};
Checkbox.create = createShorthandFactory({
  Component: Checkbox,
  mappedProp: 'label'
});
/**
 * A Checkbox allows a user to make a choice between two mutually exclusive options.
 *
 * @accessibility
 * Implements [ARIA Checkbox](https://www.w3.org/TR/wai-aria-practices-1.1/#checkbox) design pattern.
 */

export default withSafeTypeForAs(Checkbox);